"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createZodTypeGuards = createZodTypeGuards;
const common_1 = require("@finley-technologies/common");
const v4_1 = require("zod/v4");
function createZodTypeGuards(zodConfigSchema, zodNodeSchema, artifactType) {
    const isNodeConfig = (obj) => {
        const result = zodConfigSchema.safeParse(obj);
        if (!result.success) {
            (0, common_1.debugLog)(`Error validating config schema for ${artifactType}`, result.error, obj);
        }
        return result.success;
    };
    const typeGuard = (obj, customOnErrors) => {
        // use given onErrors or default to debugLog
        // strip out the db timestamps before validating.
        const updatedObj = common_1.utils.stripDbTimeStamps(obj);
        const result = zodNodeSchema.safeParse(updatedObj);
        if (!result.success) {
            const prettyError = v4_1.z.prettifyError(result.error); // This will throw if the error is not a ZodError
            const errors = [prettyError];
            if (customOnErrors) {
                customOnErrors(errors, updatedObj);
            }
            else {
                (0, common_1.debugLog)(`Error validating node schema for ${artifactType}`, errors, updatedObj);
            }
        }
        return result.success;
    };
    // isNode is a lightweight check to narrow down the type of the object
    // use it only when input is trusted DbTable.ArtifactWithSlugs.
    // for usage within tape-builder, use typeGuard instead.
    const isNode = (obj) => {
        return obj.type === artifactType;
    };
    return { isNodeConfig, typeGuard, isNode };
}
//# sourceMappingURL=typeguards.js.map